import React from 'react';
import './SmartXonnectUsage.scss';

const MediaHighlight = () => {
  const steps = [
    { label: 'Before the Ride', position: 0 },
    { label: 'On the Way', position: 50 },
    { label: 'Post the Ride', position: 100 },
  ];

  return (
    <div className="media-highlight" data-aos="fade-up">
      <h2 className="title roboto-bold">Usage of SmartXonnect</h2>
      <div className="timeline">
        <div className="line"></div>
        {steps.map((step, index) => (
          <div key={index} className="step" style={{ left: `${step.position}%` }}>
            <div className="dot"></div>
            <div className="label roboto-regular">{step.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(MediaHighlight);
